import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { REGISTER_URL } from "@/lib/site";

export const ClosingCTA = () => {
  return (
    <section data-testid="closing-cta" className="py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-5xl px-6 md:px-10 lg:px-16">
        <Reveal>
          <div className="rounded-3xl bg-brand-navy px-8 py-14 md:px-14 md:py-16 text-center">
            <h2 className="font-heading font-800 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
              Ready to stop chasing invoices?
            </h2>
            <p className="mt-4 mx-auto max-w-xl text-lg leading-relaxed text-slate-300">
              Get set up in minutes and send your first Application for Payment
              today.
            </p>
            <a
              data-testid="closing-cta-register"
              href={REGISTER_URL}
              className="mt-8 inline-flex items-center justify-center gap-2 bg-white text-brand-navy font-semibold px-7 py-3.5 rounded-lg hover:bg-slate-100 transition-colors"
            >
              Start free — no card needed
              <ArrowRight className="h-5 w-5" strokeWidth={2} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
